import {
  GET_USER_SESSION_ERROR,
  GET_USER_SESSION_SUCCESS,
} from "../actionNames";

export const setUser = (user) => ({
  type: GET_USER_SESSION_SUCCESS,
  user,
});

export const dropUser = () => ({ type: GET_USER_SESSION_ERROR });
